<template>
    <section class="bg-[#17364a] py-20 sm:py-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
                <!-- Left -->
                <div>
                    <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Contact us</span>
                    <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
                        Have a Question?<br />We'd Love to Hear From You.
                    </h2>
                    <p class="mt-5 text-sm text-gray-400 leading-relaxed max-w-md">
                        Fill out the form and we'll get back to you as soon as possible.
                    </p>
                    <div class="mt-10 flex flex-col gap-4">
                        <SocialMediaSection />
                    </div>
                </div>

                <!-- Right: form -->
                <form action="#" method="POST" class="flex flex-col gap-5">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
                        <div>
                            <label for="first-name" class="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">First name</label>
                            <input type="text" id="first-name" name="first-name" autocomplete="given-name"
                                class="w-full bg-[#102a3a] border border-[#1e4d63] px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors" />
                        </div>
                        <div>
                            <label for="last-name" class="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">Last name</label>
                            <input type="text" id="last-name" name="last-name" autocomplete="family-name"
                                class="w-full bg-[#102a3a] border border-[#1e4d63] px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors" />
                        </div>
                    </div>
                    <div>
                        <label for="contact-email" class="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">Email</label>
                        <input type="email" id="contact-email" name="email" autocomplete="email"
                            class="w-full bg-[#102a3a] border border-[#1e4d63] px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors" />
                    </div>
                    <div>
                        <label for="phone-number" class="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">Phone number</label>
                        <div class="flex">
                            <select id="country" name="country" autocomplete="country"
                                class="bg-[#102a3a] border border-r-0 border-[#1e4d63] px-3 py-3 text-sm text-gray-400 focus:outline-none focus:border-[#A07830] transition-colors">
                                <option>US</option>
                                <option>CA</option>
                                <option>EU</option>
                            </select>
                            <input type="text" id="phone-number" name="phone-number" placeholder="123-456-7890"
                                class="flex-1 bg-[#102a3a] border border-[#1e4d63] px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors" />
                        </div>
                    </div>
                    <div>
                        <label for="message" class="block text-xs font-semibold uppercase tracking-widest text-gray-400 mb-2">Message</label>
                        <textarea id="message" name="message" rows="4"
                            class="w-full bg-[#102a3a] border border-[#1e4d63] px-4 py-3 text-sm text-white placeholder-gray-600 focus:outline-none focus:border-[#A07830] transition-colors resize-none" />
                    </div>
                    <div class="flex items-center gap-3">
                        <SwitchGroup>
                            <div class="flex items-center gap-3">
                                <Switch v-model="agreed"
                                    :class="[agreed ? 'bg-[#A07830]' : 'bg-[#1e4d63]', 'relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none']">
                                    <span :class="[agreed ? 'translate-x-4' : 'translate-x-0', 'inline-block h-4 w-4 transform rounded-full bg-white transition duration-200 ease-in-out']" />
                                </Switch>
                                <SwitchLabel class="text-xs text-gray-500">
                                    I agree to the <a href="/privacy-policy" class="text-[#A07830] hover:underline">privacy policy</a>.
                                </SwitchLabel>
                            </div>
                        </SwitchGroup>
                    </div>
                    <button type="submit"
                        class="w-full py-3.5 text-sm font-semibold bg-[#A07830] text-white hover:bg-[#C9A55A] transition-colors duration-200">
                        Send Message
                    </button>
                </form>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue';
import SocialMediaSection from '@/components/sections/SocialMediaSection.vue';

const agreed = ref(false);
</script>
